import request from '@/utils/request'

export function login(username, password,code,sid) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password,code,sid
    }
  })
}
export function listcateall() {
  return request({
    url: '/valuescode/listCateAll',
    method: 'get'
  })
}
export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}
export function getCodeImg() {
  return request({
    url: '/admin/getCode',
    method: 'get'
  })
}

export function getCaptcha(data) {
  return request({
    url: '/admin/getCaptcha',
    method: 'post',
    data: data
  })
}

export function register(data) {
  return request({
    url: '/employer/register',
    method: 'post',
    data
  })
}

export function ssologin(params) {
  return request({
    url: '/admin/ssologin',
    method: 'get',
    params: params
  })
}

export function passwordExpired() {
  return request({
    url: '/admin/passwordExpired',
    method: 'get',
  })
}
export function demologin(params) {
  return request({
    url: '/admin/demologin',
    method: 'get',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js